export const initFooterAccordion = () => {
  const ANIMATION_DURATION = 240;
  const footer = document.querySelector('.site-footer');
  const animationState = new WeakMap();
  let resizeFrameId = 0;

  if (!footer) {
    return;
  }

  const cleanupListStyles = (list) => {
    list.style.transition = '';
    list.style.overflow = '';
    list.style.height = '';
    list.style.opacity = '';
  };

  const stopAnimation = (list) => {
    const state = animationState.get(list);

    if (!state) {
      return;
    }

    clearTimeout(state.fallbackTimer);
    list.removeEventListener('transitionend', state.onEnd);
    animationState.delete(list);
  };

  const openList = (list) => {
    stopAnimation(list);

    list.style.display = 'block';
    const endHeight = list.scrollHeight;

    list.style.overflow = 'hidden';
    list.style.height = '0px';
    list.style.opacity = '0';

    list.offsetHeight;

    list.style.transition = `height ${ANIMATION_DURATION}ms ease, opacity ${ANIMATION_DURATION}ms ease`;
    list.style.height = `${endHeight}px`;
    list.style.opacity = '1';

    const onEnd = (event) => {
      if (event.target !== list || event.propertyName !== 'height') {
        return;
      }

      stopAnimation(list);
      cleanupListStyles(list);
    };

    const fallbackTimer = setTimeout(() => {
      stopAnimation(list);
      cleanupListStyles(list);
    }, ANIMATION_DURATION + 60);

    animationState.set(list, { onEnd, fallbackTimer });
    list.addEventListener('transitionend', onEnd);
  };

  const closeList = (list) => {
    stopAnimation(list);

    list.style.display = 'block';
    const startHeight = list.scrollHeight;

    list.style.overflow = 'hidden';
    list.style.height = `${startHeight}px`;
    list.style.opacity = '1';

    list.offsetHeight;

    list.style.transition = `height ${ANIMATION_DURATION}ms ease, opacity ${ANIMATION_DURATION}ms ease`;
    list.style.height = '0px';
    list.style.opacity = '0';

    const onEnd = (event) => {
      if (event.target !== list || event.propertyName !== 'height') {
        return;
      }

      stopAnimation(list);
      list.style.display = 'none';
      cleanupListStyles(list);
    };

    const fallbackTimer = setTimeout(() => {
      stopAnimation(list);
      list.style.display = 'none';
      cleanupListStyles(list);
    }, ANIMATION_DURATION + 60);

    animationState.set(list, { onEnd, fallbackTimer });
    list.addEventListener('transitionend', onEnd);
  };

  const syncFooterLists = () => {
    const lists = footer.querySelectorAll('.site-footer__list');

    if (window.innerWidth >= 1024) {
      lists.forEach((list) => {
        stopAnimation(list);
        list.style.display = '';
        cleanupListStyles(list);
      });

      return;
    }

    lists.forEach((list) => {
      const title = list.previousElementSibling;
      const toggle = title?.querySelector('.site-footer__toggle');

      if (!toggle) {
        return;
      }

      const isExpanded = toggle.classList.contains('site-footer__toggle--expanded');
      stopAnimation(list);
      list.style.display = isExpanded ? 'block' : 'none';
      cleanupListStyles(list);
    });
  };

  syncFooterLists();
  window.addEventListener('resize', () => {
    window.cancelAnimationFrame(resizeFrameId);
    resizeFrameId = window.requestAnimationFrame(syncFooterLists);
  });

  footer.addEventListener('click', (event) => {
    if (window.innerWidth >= 1024) {
      return;
    }

    if (!(event.target instanceof Element)) {
      return;
    }

    const openSub = event.target.closest('.site-footer__toggle--collapsed');

    if (openSub && footer.contains(openSub)) {
      event.preventDefault();

      openSub.classList.remove('site-footer__toggle--collapsed');
      openSub.classList.add('site-footer__toggle--expanded');

      const list = openSub.parentElement?.nextElementSibling;

      if (list) {
        openList(list);
      }

      return;
    }

    const arrow = event.target.closest('.site-footer__toggle--expanded .site-footer__arrow');

    if (!arrow || !footer.contains(arrow)) {
      return;
    }

    event.preventDefault();

    const activeLink = arrow.parentElement;

    if (!activeLink) {
      return;
    }

    activeLink.classList.add('site-footer__toggle--collapsed');
    activeLink.classList.remove('site-footer__toggle--expanded');

    const title = activeLink.closest('.site-footer__title');
    const list = title?.nextElementSibling;

    if (list) {
      closeList(list);
    }
  });
};
